// Modules
import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi, } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { TranslateModule } from '@ngx-translate/core'
import { GridsterModule } from 'angular-gridster2'
import { CountdownModule } from 'ngx-countdown'
// Components
import { BackComponent } from '@component/back/back.component'
import { ExitComponent } from '@component/exit/exit.component'
import { GameComponent } from '@component/game/game.component'
import { HeaderComponent } from '@component/header/header.component'
import { InfoComponent } from '@component/info/info.component'
import { MuteComponent } from '@component/mute/mute.component'
import { PopupComponent, PopupContainerComponent } from '@component/popup/popup.component'
import { ResultComponent } from '@component/result/result.component'
import { ScoreComponent } from '@component/score/score.component'
import { TimeComponent } from '@component/time/time.component'
import { DialogComponent, DialogContainerComponent } from './component/dialog/dialog.component'
import { MascotHappyComponent } from './component/mascot/mascot-happy/mascot-happy.component'
import { MascotSadComponent } from './component/mascot/mascot-sad/mascot-sad.component'
import { SettingsComponent } from './component/settings/settings.component'
import { SpaceComponent } from './component/space/space.component'
// Utils
import { ToMinutesPipe } from '@shared/pipes/toMinutes.pipe'
import { GridDirective } from './directives/grid.directive'
import { LetDirective } from './directives/let.directive'
import { RepeatPipe } from './pipes/repeat.pipe'
import { RgbPipe } from './pipes/rgb.pipe'

const sharedComponents = [
  GameComponent,
  // Helpers
  BackComponent,
  MuteComponent,
  HeaderComponent,
  ScoreComponent,
  TimeComponent,
  PopupComponent,
  PopupContainerComponent,
  ResultComponent,
  InfoComponent,
  SettingsComponent,
  DialogComponent,
  DialogContainerComponent,
  SpaceComponent,
  // Exit
  ExitComponent,
  // Mascot
  MascotHappyComponent,
  MascotSadComponent,
]

const sharedDirectives = [
  GridDirective,
  LetDirective,
]

const sharedPipes = [
  RgbPipe,
  RepeatPipe,
  ToMinutesPipe
]

const sharedModules = [
  GridsterModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  RouterModule,
  CountdownModule
]

@NgModule({
  declarations: [
    ...sharedComponents,
    ...sharedDirectives,
    ...sharedPipes,
  ],
  imports: [
    CommonModule,
    ...sharedModules
  ],
  exports: [
    ...sharedComponents,
    ...sharedDirectives,
    ...sharedPipes,
    ...sharedModules
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class SharedModule {
}
